import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ErrorIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 1.25C6.0723 1.25 1.25 6.0723 1.25 12C1.25 17.9277 6.0723 22.75 12 22.75C17.9277 22.75 22.75 17.9277 22.75 12C22.75 6.0723 17.9277 1.25 12 1.25ZM12 21.25C6.8994 21.25 2.75 17.1006 2.75 12C2.75 6.8994 6.8994 2.75 12 2.75C17.1006 2.75 21.25 6.8994 21.25 12C21.25 17.1006 17.1006 21.25 12 21.25Z"
        fill={color}
      />
      <path
        d="M16.5302 7.46969C16.2372 7.17669 15.7626 7.17669 15.4697 7.46969L11.9999 10.9394L8.53025 7.46969C8.23725 7.17669 7.76265 7.17669 7.46975 7.46969C7.17685 7.76269 7.17675 8.23729 7.46975 8.53019L10.9394 11.9999L7.46975 15.4696C7.17675 15.7626 7.17675 16.2372 7.46975 16.5301C7.61625 16.6766 7.80815 16.7498 8.00005 16.7498C8.19195 16.7498 8.38385 16.6766 8.53035 16.5301L12.0001 13.0604L15.4698 16.5301C15.6163 16.6766 15.8077 16.7498 16.0001 16.7498C16.1925 16.7498 16.3839 16.6766 16.5304 16.5301C16.8234 16.2371 16.8234 15.7625 16.5304 15.4696L13.0606 11.9999L16.5304 8.53019C16.8234 8.23719 16.8232 7.76259 16.5302 7.46969Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ErrorIcon.displayName = 'ErrorIcon';
